<template>
  <div class="w-full h-full">
    <div class="flex justify-between items-center">
      <div class="title text-lg mb-10px cursor-pointer">
        <el-page-header
          v-if="formProps.pageType === 'read'"
          @back="$emit('cancel')"
          content="详情"
        ></el-page-header>
        <span
          v-if="formProps.pageType !== 'read'"
          class="border-l-3 border-color-primary pl-10px text-18px"
          >{{ formProps.pageType === 'create' ? '新增' : '编辑' }}</span
        >
      </div>
    </div>
    <div
      class="w-full overflow-y-auto overflow-x-hidden"
      :class="[formProps.pageType === 'read' ? 'detail-height' : 'custom-height']"
    >
      <el-form ref="form" label-width="150px" class="mr-20px" :rules="rules" :model="formData">
        <el-collapse v-model="collapseActiveName">
          <el-collapse-item title="事故风险分析" name="accidentInfo">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item label="卡片名称" prop="cardName">
                  <el-input
                    v-model="formData.cardName"
                    placeholder="请输入卡片名称"
                    maxlength="50"
                    show-word-limit
                    clearable
                    :disabled="formProps.pageType === 'read'"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item label="卡片编号" prop="cardNum">
                  <el-input
                    v-model="formData.cardNum"
                    placeholder="请输入卡片编号"
                    maxlength="50"
                    show-word-limit
                    clearable
                    :disabled="formProps.pageType === 'read'"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item label="事故类型" prop="accidentType">
                  <el-select
                    v-model="formData.accidentType"
                    placeholder="请选择事故类型"
                    class="w-full"
                    clearable
                    filterable
                    :disabled="formProps.pageType === 'read'"
                  >
                    <el-option
                      v-for="item in accidentClassList"
                      :key="item.code"
                      :label="item.displayName"
                      :value="Number(item.code)"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item label="发生区域" prop="occurredAreaId">
                  <el-select
                    v-model="formData.occurredAreaId"
                    placeholder="请选择发生区域"
                    class="w-full"
                    clearable
                    filterable
                    :disabled="formProps.pageType === 'read'"
                  >
                    <el-option
                      v-for="item in areaList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item label="可能发生的时间" prop="occurrencePossibleTime">
                  <el-date-picker
                    :disabled="formProps.pageType === 'read'"
                    size="small"
                    v-model="formData.occurrencePossibleTime"
                    style="width: 100%;"
                    class="w-full"
                    format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    placeholder="可能发生的时间"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item label="影响范围" prop="influenceScope">
                  <el-input
                    v-model="formData.influenceScope"
                    placeholder="请输入影响范围"
                    maxlength="50"
                    show-word-limit
                    clearable
                    :disabled="formProps.pageType === 'read'"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
                <el-form-item label="可能导致的事故" prop="mayResultAccidents">
                  <el-select
                    v-model="formData.mayResultAccidents"
                    placeholder="请选择可能导致的事故"
                    class="w-full"
                    clearable
                    filterable
                    :disabled="formProps.pageType === 'read'"
                  >
                    <el-option
                      v-for="item in accidentTypeList"
                      :key="item.code"
                      :label="item.displayName"
                      :value="Number(item.code)"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item label="具体地点" prop="specificLocations">
                  <el-input
                    v-model="formData.specificLocations"
                    placeholder="请输入具体地点"
                    type="textarea"
                    :rows="4"
                    maxlength="5000"
                    show-word-limit
                    clearable
                    :disabled="formProps.pageType === 'read'"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item label="出现的征兆" prop="appearanceSigns">
                  <el-input
                    v-model="formData.appearanceSigns"
                    placeholder="请输入出现的征兆"
                    type="textarea"
                    :rows="4"
                    maxlength="5000"
                    show-word-limit
                    clearable
                    :disabled="formProps.pageType === 'read'"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item label="衍生事故" prop="derivativeAccidents">
                  <el-input
                    v-model="formData.derivativeAccidents"
                    placeholder="请输入衍生事故"
                    type="textarea"
                    :rows="4"
                    maxlength="5000"
                    show-word-limit
                    clearable
                    :disabled="formProps.pageType === 'read'"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item title="应急工作职责" name="jobInfo">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item
                  label="应急工作组及职责"
                  prop="emergencyResponseTaskForceResponsibilities"
                >
                  <el-input
                    v-model="formData.emergencyResponseTaskForceResponsibilities"
                    placeholder="请输入应急工作组及职责"
                    type="textarea"
                    :rows="4"
                    maxlength="5000"
                    show-word-limit
                    clearable
                    :disabled="formProps.pageType === 'read'"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item title="应急处置" name="dealInfo">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item label="应急处置程序" prop="emergencyProcedures">
                  <el-input
                    v-model="formData.emergencyProcedures"
                    placeholder="请输入应急处置程序"
                    type="textarea"
                    :rows="4"
                    maxlength="5000"
                    show-word-limit
                    clearable
                    :disabled="formProps.pageType === 'read'"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item label="现场处置措施" prop="onSiteDisposalMeasures">
                  <el-input
                    v-model="formData.onSiteDisposalMeasures"
                    placeholder="请输入现场处置措施"
                    type="textarea"
                    :rows="4"
                    maxlength="5000"
                    show-word-limit
                    clearable
                    :disabled="formProps.pageType === 'read'"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item label="报警电话" prop="policeCall">
                  <el-input
                    v-model="formData.policeCall"
                    placeholder="请输入报警电话"
                    type="textarea"
                    :rows="4"
                    maxlength="5000"
                    show-word-limit
                    clearable
                    :disabled="formProps.pageType === 'read'"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item label="事故报告内容" prop="accidentReportContents">
                  <el-input
                    v-model="formData.accidentReportContents"
                    placeholder="请输入事故报告内容"
                    type="textarea"
                    :rows="4"
                    maxlength="5000"
                    show-word-limit
                    clearable
                    :disabled="formProps.pageType === 'read'"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
          <el-collapse-item title="注意事项" name="noticeInfo">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item label="注意事项" prop="precautions">
                  <el-input
                    v-model="formData.precautions"
                    placeholder="请输入注意事项"
                    type="textarea"
                    :rows="4"
                    maxlength="5000"
                    show-word-limit
                    clearable
                    :disabled="formProps.pageType === 'read'"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-item>
        </el-collapse>
      </el-form>
    </div>
    <div
      class="w-full flex justify-center items-center mt-5 mb-5"
      v-if="formProps.pageType !== 'read' && formProps.pageType !== 'refreshPublish'"
    >
      <el-button type="primary" size="small" @click="submitForm" :loading="loading">保存</el-button>
      <el-button @click="closeDialog" size="small">取消</el-button>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { AreaApi } from '@wiz-api/area-management'
import utils from '@/components/safety/enumField/utils'
import { DisposalMethodEmergencyCardApi } from '@wiz-api/double-prevention-management'

const areaApi = new AreaApi()
const disposalMethodEmergencyCardApi = new DisposalMethodEmergencyCardApi()
export default {
  name: 'staff-harm-form',
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    /**
     * @description: 上传传递的参数
     * @param {控制弹窗显示隐藏} visible
     * @return {*}
     */
    formProps: {
      type: Object,
      default: () => {
        return {
          // create 新增 update 编辑 read 详情
          pageType: 'create',
        }
      },
    },
  },
  data() {
    return {
      collapseActiveName: ['accidentInfo', 'jobInfo', 'dealInfo', 'noticeInfo'],
      loading: false,
      formData: {},
      accidentClassList: [],
      accidentTypeList: [],
      rules: {
        cardName: [{ required: true, message: '请输入卡片名称', trigger: ['blur', 'change'] }],
        cardNum: [{ required: true, message: '请输入卡片编号', trigger: ['blur', 'change'] }],
        accidentType: [{ required: true, message: '请选择事故类型', trigger: ['blur', 'change'] }],
        occurredAreaId: [
          { required: true, message: '请选择发生的区域', trigger: ['blur', 'change'] },
        ],
      },
      contractList: [],
      areaList: [],
    }
  },
  created() {
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.AccidentClass',
        'DoublePreventionManagement.DataCategory.AccidentType',
      ],
      ['accidentClassList', 'accidentTypeList'],
      this
    )
    // 获取区域列表
    this.getAreaList()
  },
  watch: {
    FormData: {
      handler(newVal, oldVal) {
        this.formData = newVal
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      },
      immediate: true,
    },
  },
  methods: {
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    // 表单提交
    async submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.formData.occurrencePossibleTime = this.formData.occurrencePossibleTime
            ? dayjs(this.formData.occurrencePossibleTime).format('YYYY-MM-DD HH:mm:ss')
            : undefined
          if (this.formProps.pageType === 'create') {
            const [err, res] = await disposalMethodEmergencyCardApi.create({ body: this.formData })
            if (!err) {
              this.$emit('refreshList')
              this.$message({
                showClose: true,
                message: '新增成功',
                type: 'success',
              })
            }
          } else {
            const [err, res] = await disposalMethodEmergencyCardApi.update(this.formData.id, {
              body: this.formData,
            })
            if (!err) {
              this.$emit('refreshList')
              this.$message({
                showClose: true,
                message: '编辑成功',
                type: 'success',
              })
            }
          }
          this.loading = false
        }
      })
    },
    // 关闭弹窗
    closeDialog() {
      this.$emit('cancel')
    },
  },
}
</script>

<style scoped lang="scss">
.custom-height {
  height: calc(100% - 95px);
}

.detail-height {
  height: calc(100% - 50px);
}
</style>
